'use client';

import { Button } from '@workspace/ui/components/button';
import { Icon } from '../ui';
import { cn } from '@workspace/ui/lib/utils';
import { useProfile } from '@/src/hooks/use-profile';
import { useBoolean } from '@/src/hooks/use-boolean';
import { ProfileNotifications } from '../ui/ProfileNotifications';
import { AvatarWithOptions } from '../ui/AvatarWithOptions';
import { CreateContentButton } from '../ui/CreateContentButton';
import { Modal } from '@/src/sections/social/components/Modal';
import { ButtonsBlock } from '@/src/sections/home/components/ButtonsBlock';
import Link from 'next/link';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useGameBySlug } from '@/src/hooks/use-game-by-slug';
import { PostForm } from '@/src/sections/social/components/PostForm';

export const FooterSocial = () => {
  const { data: profile, isLoading } = useProfile();
  const isNotificationsOpen = useBoolean(false);
  const isOpenPostModal = useBoolean(false);
  const isAnonymous = profile?.type === 'anonymous';
  const searchParams = useSearchParams();
  const gameSlug = searchParams.get('game') ?? '';
  const { data: game } = useGameBySlug(gameSlug, !!gameSlug);

  if (isAnonymous) {
    return (
      <footer
        className={cn(
          'md:hidden fixed bottom-0 left-0 right-0 z-50 w-full h-[56px]'
        )}
      >
        <div className="border-t-1 flex items-center relative justify-between bg-background w-full h-full px-4 m-auto">
          <Link href="/">
            <Image
              src="/icons/logo.svg"
              alt="logo"
              width={115}
              height={19}
              priority
              className="object-contain w-[115px] h-auto"
            />
          </Link>
          <ButtonsBlock isAnonymous />
        </div>
      </footer>
    );
  }

  return (
    <>
      {/* <footer
        className={cn(
          'md:hidden flex items-center justify-between sticky md:bottom-9 md:px-9 bottom-0 z-45 w-full h-[56px] md:h-10'
        )}
      > */}
      <footer
        className={cn(
          'md:hidden fixed bottom-0 left-0 right-0 z-50 w-full h-[56px]'
        )}
      >
        <div className="md:hidden border-t-1 flex items-center relative justify-between bg-background w-full h-full px-4 m-auto">
          <div className="flex flex-col items-center justify-between h-10">
            <Icon name="lvl" className="w-7 h-3" />
            <Icon name={`${profile?.level ?? 0}`} className="h-6 w-2" />
          </div>
          <div className="flex flex-col items-center h-10 justify-between">
            <Icon name="tkn" className="w-7 h-4" />
            <span className="text-base font-bold font-grotesk">
              {profile?.tokens ?? 0}{' '}
              <Icon name="tokens" className="size-3 inline-block ml-1" />
            </span>
          </div>
          <CreateContentButton
            profile={profile}
            isOpenModal={isOpenPostModal.onTrue}
          />

          <ProfileNotifications
            isNotificationsOpen={isNotificationsOpen}
            profile={profile!}
          >
            <Button
              size="icon"
              variant="ghost"
              className={cn(
                'cursor-pointer px-3.5 py-2.5 hover:bg-bg-gray hover:custom-border w-[46px] h-10 relative',
                { 'bg-black hover:bg-black/80': isNotificationsOpen.value }
              )}
            >
              <Icon
                name="bell"
                className={cn('size-6', {
                  'text-white': isNotificationsOpen.value,
                })}
              />
              {profile?.isNewNotifications && (
                <div className="absolute top-2 right-2 rounded-full size-2 bg-blue-primary" />
              )}
            </Button>
          </ProfileNotifications>

          <AvatarWithOptions />
        </div>
      </footer>

      <Modal open={isOpenPostModal.value} isPost>
        <PostForm
          isNotHome
          profile={profile}
          onCloseModal={isOpenPostModal.onFalse}
          game={game ? game : undefined}
        />
      </Modal>
    </>
  );
};

